import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {PosterEditorPageOptionsPanelProps} from '@Panels/poster-editor-page-options-panel/poster-editor-page-options-panel.types';

export const openPosterEditorPageOptionsModal = (props?: PosterEditorPageOptionsPanelProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.POSTER_EDITOR_PAGE_OPTIONS_MODAL,
      panelProps: {...props},
    })
  );
};
